import { css, keyframes, cx } from 'emotion';
import React__default, { createElement, Component, forwardRef, useRef, useContext, useState, useMemo, useEffect, Children, cloneElement } from 'react';
import { NavLink, Link } from 'react-router-dom';
import objectFitImages from 'object-fit-images';
import { Pager } from '@portal-site/pager';
import '@portal-site/pager/dist/style.css';
import { ThumbsUp } from 'react-feather';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var button_base = /*#__PURE__*/css({
  name: "1thjfy1",
  styles: "outline:none;border:none;background-color:transparent;cursor:pointer;"
});

var pulse = /*#__PURE__*/keyframes({
  name: "1x71l8j",
  styles: "0%{background-position:100% 50%;}100%{background-position:0 50%;}"
});

var skeleton_animation = /*#__PURE__*/css("background:linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);background-size:400% 100%;animation:", pulse, "  1.6s ease infinite;");

var emptyObj = {};
/**
 * 检测是否为函数
 */

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

var Skeleton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Skeleton, _React$Component);

  function Skeleton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Skeleton.prototype;

  _proto.renderContent = function renderContent() {
    var _this$props = this.props,
        renderSkeleton = _this$props.renderSkeleton,
        render = _this$props.render;

    if (typeof render === 'function') {
      return render();
    }

    if (typeof renderSkeleton === 'function') {
      if (process.env.NODE_ENV === 'development') {
        console.warn('renderSkeleton 已被render替换，请使用render');
      }

      return renderSkeleton();
    }

    return createElement(Paragraph, null);
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props2 = this.props,
        loading = _this$props2.loading,
        children = _this$props2.children,
        animation = _this$props2.animation,
        className = _this$props2.className,
        _this$props2$style = _this$props2.style,
        style = _this$props2$style === void 0 ? emptyObj : _this$props2$style;

    if (loading) {
      return createElement("div", {
        className: cx( /*#__PURE__*/css("display:inline-block;margin:1.5rem 0;width:100%;&.portal-skeleton-animation{.portal-skeleton-element{", skeleton_animation, "}}"), 'portal-skeleton', className, {
          'portal-skeleton-animation': animation
        }),
        style: style
      }, this.renderContent());
    }

    return children;
  };

  _proto.render = function render() {
    return this.renderChildren();
  };

  return Skeleton;
}(Component);
Skeleton.defaultProps = {
  loading: true,
  animation: true
};
var Card = function Card() {
  return createElement("div", {
    className: cx('portal-skeleton-card', /*#__PURE__*/css({
      name: "1sgs225",
      styles: "width:268px;height:320px;margin:16px;box-shadow:0px 0px 5px 3px #f7f9fa;"
    }))
  }, createElement(Avatar, {
    style: {
      width: '100%',
      height: 200
    },
    shape: "rect"
  }), createElement("div", {
    style: {
      padding: 14
    }
  }, createElement(Title, null), createElement(Line, null), createElement(Line, null)));
};
var List = function List() {
  return createElement("div", {
    className: cx('portal-skeleton-list', /*#__PURE__*/css({
      name: "137dqjn",
      styles: "display:flex;justify-content:space-around;padding:16px 24px;border-bottom:1px solid #f0f0f0;"
    }))
  }, createElement(Avatar, {
    style: {
      width: 48,
      height: 48
    }
  }), createElement("div", {
    style: {
      width: 'calc(100% - 120px)'
    }
  }, createElement(Title, null), createElement(Paragraph, {
    rows: 3
  })));
};
var Paragraph = function Paragraph(_ref) {
  var _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 4 : _ref$rows,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '70%' : _ref$width,
      className = _ref.className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? emptyObj : _ref$style;
  return createElement("div", {
    className: cx('portal-skeleton-paragraph', className)
  }, [].concat(Array(rows).fill(0)).map(function (_, index) {
    return createElement(Line, {
      width: getWidth(index, rows, width),
      style: style,
      key: index
    });
  }));
};
var Avatar = function Avatar(_ref2) {
  var _ref2$shape = _ref2.shape,
      shape = _ref2$shape === void 0 ? 'circle' : _ref2$shape,
      className = _ref2.className,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? emptyObj : _ref2$style;
  return createElement("span", {
    className: cx('portal-skeleton-avatar', 'portal-skeleton-element', /*#__PURE__*/css("display:inline-block;vertical-align:top;background:#f2f2f2;width:32px;height:32px;line-height:32px;", shape === 'circle' && 'border-radius:50%'), className),
    style: style
  });
};
var Title = function Title(_ref3) {
  var className = _ref3.className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? emptyObj : _ref3$style,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '35%' : _ref3$width;
  return (// eslint-disable-next-line jsx-a11y/heading-has-content
    createElement("h3", {
      className: cx('portal-skeleton-title', 'portal-skeleton-element', /*#__PURE__*/css({
        name: "c7iagu",
        styles: "height:20px;margin-top:16px;background:#f2f2f2;display:inline-block;margin:0;padding:0;"
      }), className),
      style: _extends({
        width: width
      }, style)
    })
  );
};
var Line = function Line(_ref4) {
  var _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? '100%' : _ref4$width,
      _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? '14px' : _ref4$height,
      className = _ref4.className,
      _ref4$style = _ref4.style,
      style = _ref4$style === void 0 ? emptyObj : _ref4$style;
  return createElement("span", {
    style: _extends({
      width: width,
      height: height
    }, style),
    className: cx('portal-skeleton-line', 'portal-skeleton-element', /*#__PURE__*/css({
      name: "r4kqdm",
      styles: "background-color:#f2f2f2;margin-top:16px;display:inline-block;"
    }), className)
  });
};
Skeleton.Paragraph = Paragraph;
Skeleton.Avatar = Avatar;
Skeleton.Title = Title;
Skeleton.Line = Line;
Skeleton.Card = Card;
Skeleton.List = List;

function getWidth(index, rows, width) {
  if (Array.isArray(width)) {
    return width[index];
  }

  if (rows - 2 === index) {
    return '85%';
  }

  if (rows - 1 === index) {
    return width;
  }

  return undefined;
}

var fallback_svg = "data:image/svg+xml,%20%3Csvg%20viewBox%3D%220%200%201024%201024%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22256%22%20height%3D%22256%22%3E%20%20%20%20%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cstyle%20%2F%3E%20%20%20%20%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M66.862%20150.325v723.35h890.276v-723.35H66.862zm834.634%20667.707H122.504V205.967h778.992v612.065zm-222.57-472.959c0%2046.092%2037.359%2083.464%2083.465%2083.464%2046.105%200%2083.464-37.372%2083.464-83.464s-37.36-83.45-83.464-83.45c-46.106%200-83.464%2037.358-83.464%2083.45zm166.928%20417.303H178.146l166.927-445.124%20222.57%20278.21L678.926%20512l166.927%20250.377zm0%200%22%20%20%20%20%20%20%20%20%20%20%20%20fill%3D%22%23dbdbdb%22%20%20%20%20%20%20%20%20%2F%3E%3C%2Fsvg%3E";

var PortalUIContext = /*#__PURE__*/React__default.createContext({
  assetsPrefix: '',
  pictureFallback: ''
});
var PortalUIConsumer = PortalUIContext.Consumer;
var PortalUIProvider = PortalUIContext.Provider;

var testReg = /^http[s]{0,1}:/; // 检测当前路径是否为完整图片路径

function isUrl(src) {
  return testReg.test(src);
}
/**
 * Picture组件等同于 img 元素，但提供了默认图、地址过滤、polyfill等功能
 */

var Picture = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _resolvedRef$current;

  var source = _ref.source,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? fallback_svg : _ref$fallback,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? undefined : _ref$base,
      alt = _ref.alt,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["source", "fallback", "base", "alt", "className", "style"]);

  var defaultRef = useRef(null);
  var resolvedRef = ref || defaultRef;
  var config = useContext(PortalUIContext);

  var _useState = useState(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var _base = base !== null && base !== void 0 ? base : config.assetsPrefix;

  var _fallback = fallback || config.pictureFallback;

  var sourceSets = useMemo(function () {
    var sourceArr = Array.isArray(source) ? source : [source];
    var result = sourceArr.filter(Boolean).map(function (src) {
      return isUrl(src) ? src : _base + src;
    }); // 考虑到占位图一般是本地的

    result.push(_fallback);
    return result;
  }, [source, _base, _fallback]);
  useEffect(function () {
    var current = resolvedRef.current;
    current.src = sourceSets.shift();

    function onError() {
      var src = sourceSets.length > 0 ? sourceSets.shift() : '';
      src && (current.src = src);
      current.dataset.imgSrc = src;

      if (!sourceSets.length && !fallback) {
        current.style.display = 'none';
      }
    }

    function onLoad() {
      objectFitImages(current, {
        watchMQ: true
      });
      setLoading(false);
    }

    if (current) {
      current.onload = onLoad;
      current.onerror = onError;
    } // 将图片src 设置为 "" ,可以取消正在加载的图片
    // 事件要取消


    return function () {
      current.src = '';
      current.onload = null;
      current.onerror = null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceSets]);
  return createElement("figure", Object.assign({
    style: style,
    className: cx( /*#__PURE__*/css({
      name: "bvybze",
      styles: "border-radius:2px;position:relative;display:flex;align-items:center;justify-content:center;background-color:#f7f7f7;overflow:hidden;"
    }), loading && skeleton_animation, 'portal-picture', className)
  }, rest), createElement("img", {
    className: cx( /*#__PURE__*/css({
      name: "16pe6ju",
      styles: "height:100%;max-width:100%;object-fit:contain;"
    }), {
      'is-fallback': ((_resolvedRef$current = resolvedRef.current) === null || _resolvedRef$current === void 0 ? void 0 : _resolvedRef$current.src) === fallback_svg
    }),
    alt: alt,
    ref: resolvedRef
  }));
});
Picture.defaultProps = {
  base: undefined,
  alt: '',
  className: ''
};

var Nav = function Nav(_ref) {
  var _ref$exclude = _ref.exclude,
      exclude = _ref$exclude === void 0 ? [] : _ref$exclude,
      routes = _ref.routes,
      renderNavLink = _ref.renderNavLink,
      renderChildrenNavLink = _ref.renderChildrenNavLink;
  var _renderNavLinks = null;
  var _renderChildrenNavLinks = null;

  if (isFunction(renderNavLink)) {
    _renderNavLinks = renderNavLink;
  } else {
    _renderNavLinks = function _renderNavLinks(route) {
      if (route.url && isUrl(route.url)) {
        return createElement("a", {
          href: route.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, route.name);
      }

      return createElement(NavLink, {
        to: route.url !== '/' && route.url ? route.url : route.path
      }, route.name);
    };
  }

  if (isFunction(renderChildrenNavLink)) {
    _renderChildrenNavLinks = renderChildrenNavLink; // 如果指定了一级导航渲染函数 则二级导航相同
  } else if (isFunction(renderNavLink)) {
    _renderChildrenNavLinks = renderNavLink;
  } else {
    _renderChildrenNavLinks = function _renderChildrenNavLinks(child) {
      if (child.url && isUrl(child.url)) {
        return createElement("a", {
          href: child.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, child.name);
      }

      return createElement(NavLink, {
        to: child.url !== '/' && child.url ? child.url : child.path
      }, child.name);
    };
  }

  return createElement("nav", {
    className: cx( /*#__PURE__*/css({
      name: "1b3tjow",
      styles: "height:88px;width:800px;ul{list-style:none;margin:0;padding:0;}a{text-decoration:none;color:#000;}"
    }), 'portal-nav')
  }, createElement("ul", {
    className: cx( /*#__PURE__*/css({
      name: "1d1nyei",
      styles: "display:flex;justify-content:space-around;align-items:center;height:100%;"
    }), 'portal-nav-firstmenu')
  }, routes.children.filter(function (item) {
    return !exclude.includes(item.route);
  }).map(function (route) {
    return createElement("li", {
      className: cx( /*#__PURE__*/css({
        name: "grjzz9",
        styles: "display:flex;justify-content:center;position:relative;flex-wrap:wrap;height:80px;align-items:center;& > a{width:100%;text-align:center;}&:hover{nav{display:flex;}}"
      }), 'portal-nav-firstmenu-li'),
      key: route.name
    }, _renderNavLinks(route), createElement("nav", {
      className: cx( /*#__PURE__*/css({
        name: "1eqrnda",
        styles: "display:none;width:200px;position:absolute;top:80px;justify-content:center;"
      }), 'portal-nav-second')
    }, createElement("ul", {
      className: "portal-nav-secondmenu"
    }, route.children.filter(function (item) {
      return !exclude.includes(item.route);
    }).map(function (child) {
      return createElement("li", {
        key: child.name
      }, _renderChildrenNavLinks(child));
    }))));
  })));
};
Nav.defaultProps = {
  exclude: []
};

var Container = function Container(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1250px' : _ref$width,
      className = _ref.className,
      children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["width", "className", "children", "style"]);

  return createElement("div", Object.assign({
    style: style,
    className: cx( /*#__PURE__*/css("flex-grow:1;margin:0 auto;position:relative;width:", width, ";"), 'portal-container', className)
  }, rest), children);
};

var Header = function Header(_ref) {
  var logo = _ref.logo,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '官网' : _ref$title,
      extra = _ref.extra,
      routes = _ref.routes;
  var isSrc = typeof logo === 'string';
  console.error('该组件即将删除,请勿使用！');
  return createElement("header", {
    className: cx( /*#__PURE__*/css({
      name: "1pytyzc",
      styles: "background-color:rgba(0,0,0,0.5);height:85px;width:100%;position:absolute;top:0;z-index:10;"
    }), 'portal-header')
  }, createElement(Container, {
    className: /*#__PURE__*/css({
      name: "nb2z2f",
      styles: "display:flex;justify-content:space-between;align-items:center;width:100%;"
    })
  }, createElement("div", {
    className: "portal-logo"
  }, isSrc ? createElement(Link, {
    to: "/",
    title: "\u9996\u9875"
  }, createElement("img", {
    className: /*#__PURE__*/css({
      name: "cnwe5g",
      styles: "vertical-align:middle;height:30px;"
    }),
    src: logo,
    alt: "logo"
  })) : logo, createElement("h1", {
    className: /*#__PURE__*/css({
      name: "jodbou",
      styles: "font-size:0;"
    })
  }, title)), createElement(Nav, {
    routes: routes,
    exclude: ['Slide']
  }), createElement("div", {
    className: "portal-header-extra"
  }, extra)));
};

var Meta = function Meta(_ref) {
  var avatar = _ref.avatar,
      title = _ref.title,
      description = _ref.description,
      secondary = _ref.secondary,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      actions = _ref.actions;
  return createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "13pmxen",
      styles: "display:flex;flex:1;"
    }), center && /*#__PURE__*/css({
      name: "zcxndt",
      styles: "align-items:center;"
    }), 'portal-list-item-meta')
  }, createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "wof6hg",
      styles: "position:relative;flex:0 0 auto;float:none;margin:0;padding:0;"
    }), 'portal-list-item-meta-avatar')
  }, avatar), createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "y0mwvl",
      styles: "flex:1 1 auto;background:0 0;margin:0;padding:0;box-shadow:none;font-size:1em;border:none;min-width:0;width:auto;align-self:top;padding-left:1.5em;"
    }), 'portal-list-item-meta-main')
  }, createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "1eul3w5",
      styles: "display:inline-block;margin:6px 0 10px;"
    }), 'portal-list-item-meta-header')
  }, createElement("h4", {
    className: /*#__PURE__*/css({
      name: "1yxorhg",
      styles: "font-size:16px;color:#595757;font-weight:normal;margin:-4px 0 0 1px;"
    })
  }, title), createElement("span", {
    className: /*#__PURE__*/css({
      name: "1axycpc",
      styles: "margin:7px 0 7px;font-size:14px;line-height:1em;color:rgba(0,0,0,0.6);"
    })
  }, secondary)), createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "19wrhku",
      styles: "line-height:1.8;text-align:justify;font-size:14px;color:#898989;"
    }), 'portal-list-item-meta-description')
  }, description), actions && createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "x72mw9",
      styles: "display:flex;position:relative;background:0 0;margin:1rem 0 0;width:100%;padding:0 0 0;top:0;left:0;box-shadow:none;border-top:none;justify-content:flex-end;"
    }), 'portal-list-item-meta-action')
  }, actions)));
};

var Item = function Item(_ref) {
  var children = _ref.children,
      _ref$extra = _ref.extra,
      extra = _ref$extra === void 0 ? null : _ref$extra;
  var extraNodes = [];

  if (extra) {
    if (!Array.isArray(extra)) {
      extra = [extra];
    }

    Children.forEach(extra, function (child, index) {
      extraNodes.push(cloneElement(child, {
        key: index
      }));
    });
  }

  return createElement("li", {
    className: cx( /*#__PURE__*/css({
      name: "lwtf2o",
      styles: "display:flex;width:100%;min-height:0;background:0 0;padding:18px 0;border-bottom:1px solid #f0f0f0;&:last-child{border-bottom:none;}"
    }), 'portal-list-item')
  }, children, extra && createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "19t1w01",
      styles: "margin-left:40px;"
    }), 'portal-list-item-extra')
  }, extraNodes));
};
Item.Meta = Meta;

var List$1 = function List(_ref) {
  var _ref$renderItem = _ref.renderItem,
      renderItem = _ref$renderItem === void 0 ? function (item) {
    return createElement(Item, null, item.title);
  } : _ref$renderItem,
      pagination = _ref.pagination,
      dataSource = _ref.dataSource,
      style = _ref.style,
      className = _ref.className;
  var items = dataSource.map(function (item, index) {
    return renderItem(item, index);
  });
  var childrenList = [];
  Children.forEach(items, function (child, index) {
    childrenList.push(cloneElement(child, {
      key: index
    }));
  });
  return createElement("div", {
    className: cx('portal-list', className),
    style: style
  }, createElement("ul", {
    className: cx( /*#__PURE__*/css({
      name: "1iruc8t",
      styles: "list-style:none;margin:0;padding:0;"
    }), 'portal-list-items')
  }, childrenList), pagination && createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "152yjzu",
      styles: "text-align:center;margin-top:70px;"
    }), 'portal-list-pagination')
  }, createElement(Pager, Object.assign({}, pagination))));
};
List$1.Item = Item;

var Like = function Like(_ref) {
  var onLikeIt = _ref.onLikeIt,
      onDislikeIt = _ref.onDislikeIt,
      cancellable = _ref.cancellable,
      Icon = _ref.icon;
  var btn = useRef(null);

  var _useState = useState(false),
      _active = _useState[0],
      setActive = _useState[1];

  useEffect(function () {
    var dom = btn.current;

    var clickHandle = function clickHandle() {
      if (dom.classList.contains('portal-like-active')) {
        if (cancellable) {
          onDislikeIt();
          setActive(false);
        }

        return;
      }

      setActive(true);
      onLikeIt();
    };

    dom.addEventListener('click', clickHandle);
    return function () {
      dom.removeEventListener('click', clickHandle);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLikeIt, onDislikeIt]);
  return createElement("button", {
    ref: btn,
    className: cx(button_base, _active && /*#__PURE__*/css({
      name: "7zn50n",
      styles: "color:#ef5353;"
    }), {
      'portal-like-active': _active
    }, 'portal-like'),
    type: "button"
  }, Icon);
};
Like.defaultProps = {
  icon: /*#__PURE__*/createElement(ThumbsUp, null),
  cancellable: false
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
  x1: "8.042%",
  y1: "0%",
  x2: "65.682%",
  y2: "23.865%",
  id: "tail-spin_svg__a"
}, /*#__PURE__*/createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.631,
  offset: "63.146%"
}), /*#__PURE__*/createElement("stop", {
  stopColor: "currentColor",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M36 18c0-9.94-8.06-18-18-18",
  stroke: "url(#tail-spin_svg__a)",
  strokeWidth: 2
}, /*#__PURE__*/createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "0.9s",
  repeatCount: "indefinite"
})), /*#__PURE__*/createElement("circle", {
  fill: "currentColor",
  cx: 36,
  cy: 18,
  r: 1
}, /*#__PURE__*/createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "0.9s",
  repeatCount: "indefinite"
})));

function SvgTailSpin(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38"
  }, props), _ref, _ref2);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("g", {
  transform: "translate(1 1)",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("circle", {
  strokeOpacity: 0.5,
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/createElement("path", {
  d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "1s",
  repeatCount: "indefinite"
})));

function SvgOval(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 38",
    stroke: "currentColor"
  }, props), _ref$1);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15
}, /*#__PURE__*/createElement("animate", {
  attributeName: "r",
  from: 15,
  to: 15,
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/createElement("animate", {
  attributeName: "fill-opacity",
  from: 1,
  to: 1,
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

var _ref2$1 = /*#__PURE__*/createElement("circle", {
  cx: 60,
  cy: 15,
  r: 9,
  fillOpacity: 0.3
}, /*#__PURE__*/createElement("animate", {
  attributeName: "r",
  from: 9,
  to: 9,
  begin: "0s",
  dur: "0.8s",
  values: "9;15;9",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/createElement("animate", {
  attributeName: "fill-opacity",
  from: 0.5,
  to: 0.5,
  begin: "0s",
  dur: "0.8s",
  values: ".5;1;.5",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

var _ref3 = /*#__PURE__*/createElement("circle", {
  cx: 105,
  cy: 15,
  r: 15
}, /*#__PURE__*/createElement("animate", {
  attributeName: "r",
  from: 15,
  to: 15,
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/createElement("animate", {
  attributeName: "fill-opacity",
  from: 1,
  to: 1,
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}));

function SvgThreeDots(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: "4em",
    height: "1em",
    viewBox: "0 0 120 30",
    fill: "currentColor"
  }, props), _ref$2, _ref2$1, _ref3);
}

var Spin = function Spin(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$indicator = _ref.indicator,
      Indicator = _ref$indicator === void 0 ? SvgTailSpin : _ref$indicator,
      _ref$spinning = _ref.spinning,
      spinning = _ref$spinning === void 0 ? true : _ref$spinning,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1890ff' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      tip = _ref.tip;
  return React__default.createElement("div", {
    style: style,
    className: cx( /*#__PURE__*/css("box-sizing:border-box;display:inline-block;margin:0;padding:0;font-variant:tabular-nums;line-height:1.5715;font-feature-settings:'tnum';text-align:center;vertical-align:middle;color:", color, ";"), 'portal-spin', spinning && 'portal-spinning', className)
  }, React__default.createElement("span", {
    className: /*#__PURE__*/css("width:1em;height:1em;color:inherit;display:inline-block;position:relative;font-size:", size, "px;svg{display:inline-block;vertical-align:top;}")
  }, spinning && React__default.createElement(Indicator, null)), React__default.createElement("span", {
    className: /*#__PURE__*/css({
      name: "h82yhi",
      styles: "display:block;font-size:14px;text-align:center;text-shadow:0 1px 2px #fff;"
    })
  }, tip));
};
Spin.SpinIndicatorC1 = SvgTailSpin;
Spin.SpinIndicatorC2 = SvgOval;
Spin.SpinIndicatorC3 = SvgThreeDots;

var CarouselLib = /*#__PURE__*/function () {
  function CarouselLib(options) {
    this.container = options.container;
    this.nav = options.nav;
    this.slides = Array.from(this.container.querySelectorAll('.portal-carousel-slide'));
    this.navItems = Array.from(this.nav.querySelectorAll('.portal-carousel-nav-item'));
    this.activeIndex = 0;
    this._timer = null;
    this.duration = options.duration;
    this.count = 0;
    this.currentItem = null;
  }

  var _proto = CarouselLib.prototype;

  _proto.init = function init() {
    var _this = this;

    this.slides.forEach(function (node) {
      node.style.opacity = '0';
      node.style.transform = "scale(1,1)";
      node.style.zIndex = '-1';
    });
    this.navItems.forEach(function (node, index) {
      node.dataset.itemIndex = index + '';
      node.addEventListener('click', function (e) {
        var target = e.currentTarget;

        _this.slideTo(+target.dataset.itemIndex);
      });
    });
    this.count = this.slides.length;
    this.animate(true).start();
    return this;
  } //　保证transitionEnd　事件只触发一次
  ;

  _proto._transitionEnd = function _transitionEnd(ele, fn) {
    var called = false;

    var callback = function callback() {
      if (!called) {
        fn.call(ele);
        called = true;
        ele.removeEventListener('transitionend', callback);
      }
    };

    ele.addEventListener('transitionend', callback);
  } // 动画
  ;

  _proto.animate = function animate(isFirst) {
    var _this2 = this;

    if (this.slides.length === 0) return this;

    if (isFirst) {
      this.currentItem = this.slides[0];
    } else {
      this.currentItem.style.opacity = '0';
      this.currentItem.style.transform = 'scale(1.5,1.5)';
      this.currentItem.style.transition = '1000ms cubic-bezier(0.5,0,0.2,1)';

      this._transitionEnd(this.currentItem, function () {
        this.style.zIndex = '-1';
        this.style.transform = 'scale(1,1)';
      });
    }

    this.currentItem = this.slides[this.activeIndex];
    this.currentItem.style.zIndex = '0';
    this.currentItem.style.opacity = '1';
    this.currentItem.style.transform = 'scale(1,1)';
    this.currentItem.style.transition = '800ms cubic-bezier(0,1,1,1)';

    this._transitionEnd(this.currentItem, function () {
      this.style.transform = 'scale(1.1,1.1)';
      this.style.transition = '5000ms linear';
    });

    this.navItems.forEach(function (nav, index) {
      index === _this2.activeIndex ? nav.classList.add('active') : nav.classList.remove('active');
    });
    return this;
  };

  _proto.slideTo = function slideTo(index) {
    this.activeIndex = index;
    this.destroy().start();
    this.animate(false);
  };

  _proto.start = function start() {
    var _this3 = this;

    this._timer = setInterval(function () {
      _this3.activeIndex++;
      if (_this3.activeIndex >= _this3.count) _this3.activeIndex = 0;

      _this3.animate(false);
    }, this.duration);
  };

  _proto.destroy = function destroy() {
    clearInterval(this._timer);
    return this;
  };

  return CarouselLib;
}();

var ins = null;
var timer = null;

var Slide = function Slide(_ref) {
  var children = _ref.children;
  return createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "jz90iv",
      styles: "position:absolute;width:100%;height:100%;top:0;left:0;z-index:0;"
    }), 'portal-carousel-slide')
  }, children);
};

var Carousel = function Carousel(_ref2) {
  var _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 200 : _ref2$delay,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? 6000 : _ref2$duration,
      _ref2$dataSource = _ref2.dataSource,
      dataSource = _ref2$dataSource === void 0 ? [] : _ref2$dataSource,
      renderSlide = _ref2.renderSlide,
      className = _ref2.className,
      style = _ref2.style;
  var wrapperRef = useRef(null);
  var navRef = useRef(null);

  var render = function render(item) {
    var imgSrc = typeof item === 'string' ? item : item.imgSrc;
    return createElement(Picture, {
      key: imgSrc,
      source: imgSrc
    });
  };

  var _renderSlide = renderSlide || render;

  useEffect(function () {
    timer = setTimeout(function () {
      ins = new CarouselLib({
        container: wrapperRef.current,
        duration: duration,
        nav: navRef.current
      }).init();
    }, delay);
    return function () {
      ins && ins.destroy();
      clearTimeout(timer);
    };
  }, [delay, duration, dataSource.length]);
  var items = dataSource.map(function (item, index) {
    return createElement(Slide, {
      key: index
    }, _renderSlide(item, index));
  });
  return createElement("div", {
    style: style,
    className: cx( /*#__PURE__*/css({
      name: "1iivyhr",
      styles: "width:100%;height:100vh;position:relative;top:0;left:0;overflow:hidden;"
    }), 'portal-carousel', className)
  }, createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "jz90iv",
      styles: "position:absolute;width:100%;height:100%;top:0;left:0;z-index:0;"
    }), 'portal-carousel-container')
  }, createElement("div", {
    ref: wrapperRef,
    className: "portal-carousel-wrappr"
  }, items), createElement("div", {
    ref: navRef,
    className: cx( /*#__PURE__*/css({
      name: "1qe5zc",
      styles: "position:absolute;bottom:5%;width:100%;left:0;text-align:center;& > .portal-carousel-nav-item.active{background-color:red;}"
    }), 'portal-carousel-nav')
  }, dataSource.map(function (_, index) {
    return createElement("i", {
      className: cx( /*#__PURE__*/css({
        name: "1vnkjmk",
        styles: "display:inline-block;width:27px;height:24px;margin:0 5px;line-height:3px;text-align:center;vertical-align:middle;cursor:pointer;background-color:#fff;border-radius:50%;"
      }), 'portal-carousel-nav-item'),
      key: index
    });
  }))));
};
Carousel.defaultProps = {
  delay: 200,
  duration: 6000
};

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: "empty_svg__a"
}, /*#__PURE__*/createElement("path", {
  d: "M0 0h64v63.871H0V0z"
})));

var _ref2$2 = /*#__PURE__*/createElement("path", {
  d: "M0 54c0-5.523 17.909-10 40-10s40 4.477 40 10-17.909 10-40 10S0 59.523 0 54z",
  fill: "#F5F5F5",
  fillRule: "evenodd"
});

var _ref3$1 = /*#__PURE__*/createElement("path", {
  d: "M8 0h64v63.871H8V0z",
  fill: "none"
});

var _ref4 = /*#__PURE__*/createElement("g", {
  clipPath: "url(#empty_svg__a)",
  fillRule: "evenodd",
  transform: "translate(8)"
}, /*#__PURE__*/createElement("path", {
  d: "M32 44.839c-7.981 0-14.452-6.47-14.452-14.452H1.032v24.774h61.936V30.387H46.452c0 7.981-6.47 14.452-14.452 14.452z",
  fill: "#FAFAFA"
}), /*#__PURE__*/createElement("path", {
  d: "M55.675 8.342l8.258 21.678c.038.106.058.217.06.33 0 .013.007.024.007.037v24.774c0 .57-.462 1.033-1.032 1.033H1.032C.462 56.194 0 55.73 0 55.16V30.387c0-.013.007-.024.007-.037a1.03 1.03 0 01.06-.33L8.325 8.342c.153-.4.537-.665.965-.665h45.42c.428 0 .812.265.965.665zm-45.673 1.4h43.996l7.472 19.613H46.452c-.57 0-1.033.462-1.033 1.032 0 7.411-6.008 13.42-13.419 13.42-7.411 0-13.42-6.009-13.42-13.42 0-.57-.462-1.032-1.032-1.032H2.53l7.472-19.613zM2.064 31.419v22.71h59.87v-22.71H47.45c-.54 8.135-7.297 14.458-15.45 14.458-8.153 0-14.91-6.323-15.45-14.458H2.065z",
  fill: "#D9D9D9"
}), /*#__PURE__*/createElement("path", {
  d: "M7.226 50H6.194v-3.097a1.032 1.032 0 00-2.065 0v4.13c0 .57.462 1.032 1.032 1.032h2.065a1.032 1.032 0 000-2.065zm6.194 0h-2.065a1.032 1.032 0 000 2.065h2.064a1.032 1.032 0 000-2.065z",
  fill: "#DCE0E6"
}));

function SvgEmpty(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 64"
  }, props), _ref$3, _ref2$2, _ref3$1, _ref4);
}

var Empty = function Empty(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? '暂无数据' : _ref$description,
      style = _ref.style,
      className = _ref.className;
  return React__default.createElement("div", {
    style: style,
    className: cx( /*#__PURE__*/css({
      name: "dzdh3v",
      styles: "margin:32px 0;color:rgba(0,0,0,0.25);font-size:14px;line-height:1.5715;text-align:center;"
    }), 'portal-empty', className)
  }, React__default.createElement("div", {
    className: /*#__PURE__*/css({
      name: "1gchtyy",
      styles: "height:80px;margin-bottom:8px;font-size:80px;svg{margin:auto;}"
    })
  }, React__default.createElement(SvgEmpty, null)), React__default.createElement("p", {
    className: /*#__PURE__*/css({
      name: "46b038",
      styles: "margin-top:30px;"
    })
  }, description));
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  d: "M512 1024C229.222 1024 0 794.778 0 512S229.222 0 512 0s512 229.222 512 512-229.222 512-512 512zm76.8-419.226c-31.027-63.18-18.364-50.944 1.843-66.577 18.944-14.694 18.057-53.162 29.645-66.901 11.776-13.96 17.186-53.828 12.766-68.898-5.871-19.968-14.865-9.045-16.213-24.115-2.953-32.495 5.154-59.222-12.92-75.025-17.46-15.275-39.322-46.797-74.923-47.258-12.407-.154-26.47 3.584-42.598 12.97-76.8-8.31-76.305 76.852-79.24 109.364-1.366 15.07-10.377 4.215-16.214 24.183-4.437 15.053.99 55.057 12.749 69.018 11.605 13.756 10.7 52.48 29.645 67.157 20.207 15.65 32.87 3.926 1.843 67.106-15.616 31.847-117.999 17.46-138.155 45.364C281.6 672.46 281.618 716.8 281.6 716.8h460.8s0-44.34-15.445-65.638c-20.139-27.887-122.539-14.507-138.155-46.388z",
  fill: "currentColor"
});

function SvgAvatar(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em"
  }, props), _ref$4);
}

var Avatar$1 = function Avatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 32 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#cccccc' : _ref$color,
      className = _ref.className,
      style = _ref.style;
  return React__default.createElement("div", {
    style: style,
    className: cx( /*#__PURE__*/css("display:inline-flex;justify-content:center;align-items:center;flex-wrap:wrap;font-size:", size, "px;width:", size, "px;height:", size, "px;color:", color, ";"), 'portal-avatar', className)
  }, React__default.createElement(SvgAvatar, null));
};

var Button = function Button(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onClick = _ref.onClick,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      bindEnterKeyboard = _ref.bindEnterKeyboard,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$htmlType = _ref.htmlType,
      htmlType = _ref$htmlType === void 0 ? 'button' : _ref$htmlType,
      rounded = _ref.rounded,
      className = _ref.className,
      style = _ref.style;
  useEffect(function () {
    var handleEnter = function handleEnter(event) {
      if (event.code === 'Enter') {
        onClick && onClick(event);
      }
    };

    if (bindEnterKeyboard) {
      window.addEventListener('keyup', handleEnter);
    }

    return function () {
      window.removeEventListener('keyup', handleEnter);
    };
  }, [onClick, bindEnterKeyboard]);
  return React__default.createElement("button", {
    style: style,
    type: htmlType,
    className: cx( /*#__PURE__*/css({
      name: "rzr2hq",
      styles: "height:32px;min-width:80px;line-height:24px;display:inline-block;color:#646464;outline:0;border:1px solid transparent;text-align:center;cursor:pointer;padding:4px 15px;border-radius:4px;transition:all 0.3s;box-sizing:border-box;user-select:none;box-shadow:none;transition:all 0.3s ease-in;.portal-spin{vertical-align:text-top;margin-right:6px;}&.btn-disabled{pointer-events:none;opacity:0.55;background-color:#eee;box-shadow:0 2px 5px 0 rgba(0,0,0,0.26);}&.btn-loading{pointer-events:none;opacity:0.55;}&.btn-md{width:108px;}&.btn-lg{width:168px;}&.btn-full{width:100%;}&.btn-primary{border-color:transparent;background-color:#4285f4;color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,0.26);&:hover{opacity:0.8;}}&.btn-default{background-color:#fff;border-color:rgba(219,219,219,0.5);border-width:1px;box-shadow:1px 2px 2px 0 rgba(0,0,0,0.05);&:hover{border-color:#cccccc;}}&.btn-rounded{border-radius:290486px;}"
    }), {
      'btn-disabled': disabled,
      'btn-loading': loading,
      'btn-md': size === 'md',
      'btn-lg': size === 'lg',
      'btn-full': size === 'full',
      'btn-primary': type === 'primary',
      'btn-default': type === 'default',
      'btn-rounded': rounded
    }, className),
    onClick: disabled || loading ? undefined : onClick
  }, loading ? React__default.createElement(React__default.Fragment, null, React__default.createElement(Spin, {
    color: "#fff",
    size: 14
  }), children) : children);
};
var ButtonGroup = function ButtonGroup(_ref2) {
  var children = _ref2.children,
      alignMiddle = _ref2.alignMiddle,
      alignRight = _ref2.alignRight,
      style = _ref2.style,
      className = _ref2.className;
  return React__default.createElement("div", {
    className: cx( /*#__PURE__*/css({
      name: "1r8sjsy",
      styles: "align-items:center;align-content:center;display:flex;flex-wrap:wrap;justify-content:flex-start;&.align-middle{justify-content:center;}&.align-right{justify-content:flex-end;}button:not(:last-child):not(.btn-full){margin-right:0.5rem;}"
    }), {
      'align-middle': alignMiddle,
      'align-right': alignRight
    }, className),
    style: style
  }, children);
};

export { Avatar$1 as Avatar, Button, ButtonGroup, Carousel, CarouselLib, Container, Empty, Header, Like, List$1 as List, Nav, Picture, PortalUIConsumer, PortalUIContext, PortalUIProvider, Skeleton, Spin };
//# sourceMappingURL=components.esm.js.map
